import React from "react";
import Select from "react-select";
import {useTranslation} from "react-i18next";

import useProjectOrderByContext from "@/services/context/project-order-by/use-project-order-by-context.ts";
import {OrderByArray, OrderByType} from "@/services/context/project-order-by/models/order-by-type.ts";

type OrderByOption = {
    value: OrderByType;
};

const orderByOptions: OrderByOption[] = OrderByArray.map((value) => ({
    value,
}));

const OrderBy: React.FC = () => {
    
    const { t } = useTranslation();
    const { orderBy, setOrderBy } = useProjectOrderByContext();

    return (
        <Select className='w-50'
                options={orderByOptions}
                value={orderByOptions.find((option) => option.value === orderBy)}
                getOptionValue={(option) => option.value}
                onChange={(option) => {if (option) setOrderBy(option.value)}}
                formatOptionLabel={(option) => t(option.value)}
                isSearchable={false}
                classNames={{
                    control: () => "!h-[2.25rem] !min-h-0 !rounded-md !border-gray-300",
                    menu: () => "text-sm",
                    menuList: () => "text-sm",
                    singleValue: () => "text-sm",
                    placeholder: () => "text-sm",
                    indicatorsContainer: () => "-my-1",
                }}
        />
    )
}

export default OrderBy;